import TurtleBadge from "../images/turtle-badge.svg";
import FishBadge from "../images/fish-badge.svg";
import PenguinBadge from "../images/penguin-badge.svg";
import DolphinBadge from "../images/dolphin-badge.svg";
import WhaleBadge from "../images/whale-badge.svg";

const badges = [
  {
    src: TurtleBadge,
    i18nKey: "badges.turtle" 
  },
  {
    src: PenguinBadge,
    i18nKey: "badges.penguin"
  },
  {
    src: FishBadge,
    i18nKey: "badges.fish"
  },
  {
    src: DolphinBadge,
    i18nKey: "badges.dolphin"
  },
  {
    src: WhaleBadge,
    i18nKey: "badges.whale" 
  }
];

export default badges;
